export interface GradeScale {
  grade: string;
  minScore?: number;
  maxScore?: number;
  points: number;
  category?: string;
  description?: string;
}

export interface University {
  id: string;
  name: string;
  shortName: string;
  gradeScale: GradeScale[];
}

export const universities: University[] = [
  {
    id: 'POLY',
    name: 'Polytechnic Bahrain',
    shortName: 'POLY',
    gradeScale: [
      // Achievement Based
      { grade: 'A+', minScore: 95, maxScore: 100, points: 4.00, category: 'Achievement Based' },
      { grade: 'A', minScore: 90, maxScore: 94, points: 3.75, category: 'Achievement Based' },
      { grade: 'A-', minScore: 85, maxScore: 89, points: 3.50, category: 'Achievement Based' },
      { grade: 'B+', minScore: 80, maxScore: 84, points: 3.25, category: 'Achievement Based' },
      { grade: 'B', minScore: 75, maxScore: 79, points: 3.00, category: 'Achievement Based' },
      { grade: 'B-', minScore: 70, maxScore: 74, points: 2.75, category: 'Achievement Based' },
      { grade: 'C+', minScore: 65, maxScore: 69, points: 2.50, category: 'Achievement Based' },
      { grade: 'C', minScore: 60, maxScore: 64, points: 2.25, category: 'Achievement Based' },
      { grade: 'F', minScore: 0, maxScore: 59, points: 0.00, category: 'Achievement Based' },
      // Competency Based
      { grade: 'Distinction', points: 4.00, category: 'Competency Based' },
      { grade: 'Merit', points: 3.25, category: 'Competency Based' },
      { grade: 'Competent', points: 2.50, category: 'Competency Based' },
      { grade: 'Not Yet Competent', points: 0.00, category: 'Competency Based' }
    ]
  },
  {
    id: 'UOB',
    name: 'University of Bahrain',
    shortName: 'UOB',
    gradeScale: [
      // Regular Grades
      { grade: 'A', minScore: 90, maxScore: 100, points: 4.00, category: 'Regular Grades' },
      { grade: 'A-', minScore: 87, maxScore: 89, points: 3.67, category: 'Regular Grades' },
      { grade: 'B+', minScore: 84, maxScore: 86, points: 3.33, category: 'Regular Grades' },
      { grade: 'B', minScore: 80, maxScore: 83, points: 3.00, category: 'Regular Grades' },
      { grade: 'B-', minScore: 77, maxScore: 79, points: 2.67, category: 'Regular Grades' },
      { grade: 'C+', minScore: 74, maxScore: 76, points: 2.33, category: 'Regular Grades' },
      { grade: 'C', minScore: 70, maxScore: 73, points: 2.00, category: 'Regular Grades' },
      { grade: 'C-', minScore: 67, maxScore: 69, points: 1.67, category: 'Regular Grades' },
      { grade: 'D+', minScore: 64, maxScore: 66, points: 1.33, category: 'Regular Grades' },
      { grade: 'D', minScore: 60, maxScore: 63, points: 1.00, category: 'Regular Grades' },
      { grade: 'F', minScore: 0, maxScore: 59, points: 0.00, category: 'Regular Grades' },
      // Special Grades
      { grade: 'E', points: 0.00, category: 'Special Grades', description: 'Exempt from the course without a grade' },
      { grade: 'I', points: 0.00, category: 'Special Grades', description: 'Incomplete' },
      { grade: 'W', points: 0.00, category: 'Special Grades', description: 'Withdrawal from the course' },
      { grade: 'WF', points: 0.00, category: 'Special Grades', description: 'Withdrawal with Fail' },
      { grade: 'WA', points: 0.00, category: 'Special Grades', description: 'Withdrawal with Acceptable Excuse' },
      { grade: 'WE', points: 0.00, category: 'Special Grades', description: 'Withdrawal with Compelling Excuse' }
    ]
  },
  {
    id: 'UTB',
    name: 'University of Technology Bahrain',
    shortName: 'UTB',
    gradeScale: [
      // Regular Grades
      { grade: 'A+', minScore: 95, maxScore: 100, points: 4.00, category: 'Regular Grades' },
      { grade: 'A', minScore: 91, maxScore: 94, points: 3.89, category: 'Regular Grades' },
      { grade: 'A-', minScore: 87, maxScore: 90, points: 3.67, category: 'Regular Grades' },
      { grade: 'B+', minScore: 83, maxScore: 86, points: 3.33, category: 'Regular Grades' },
      { grade: 'B', minScore: 79, maxScore: 82, points: 3.00, category: 'Regular Grades' },
      { grade: 'B-', minScore: 76, maxScore: 78, points: 2.67, category: 'Regular Grades' },
      { grade: 'C+', minScore: 73, maxScore: 75, points: 2.33, category: 'Regular Grades' },
      { grade: 'C', minScore: 70, maxScore: 72, points: 2.00, category: 'Regular Grades' },
      { grade: 'C-', minScore: 64, maxScore: 69, points: 1.67, category: 'Regular Grades' },
      { grade: 'D+', minScore: 57, maxScore: 63, points: 1.33, category: 'Regular Grades' },
      { grade: 'D', minScore: 50, maxScore: 56, points: 1.00, category: 'Regular Grades' },
      { grade: 'F', minScore: 0, maxScore: 49, points: 0.00, category: 'Regular Grades' },
      // Special Grades
      { grade: 'IC', points: 0.00, category: 'Special Grades', description: 'Incomplete' },
      { grade: 'IP', points: 0.00, category: 'Special Grades', description: 'In Progress' },
      { grade: 'W', points: 0.00, category: 'Special Grades', description: 'Withdrawn' },
      { grade: 'DR', points: 0.00, category: 'Special Grades', description: 'Dropped' },
      { grade: 'NG', points: 0.00, category: 'Special Grades', description: 'No Grade' }
    ]
  }
];